import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { SeriousCasesService } from '../_services/serious-cases.service';
import { SeriousCase } from '../_types/serious-case';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { selectType } from '../_types/select-type';
import { CompaniesService } from '../../companies/_services/companies.service';
import { ExpertsService } from '../../experts/_services/experts.service';
import { UsersService } from '../../users/_services/users.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { CasesService } from '../../cases/_services/cases.service';

@Component({
    selector: 'app-serious-cases-list',
    templateUrl: './serious-cases-list.component.html',
    styleUrls: ['./serious-cases-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'list-page' },
    standalone: false
})
export class SeriousCasesListComponent implements OnInit {


  public rows: SeriousCase[] = [];
  public countriesRegions: selectType[] = [];
  public companies: selectType[] = [];
  public peritos: selectType[] = [];
  public tecnicos: selectType[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any = { first: 0, rows: 100 };
  public defaultSort: string[] = ['-caseDate'];

  public filters: any = {
    id: new Filter(FilterOperation.contains, 'id'),
    estadoUSG: new Filter(FilterOperation.equals, 'estadoUSG'),
    compania: new Filter(FilterOperation.any, 'compania'),
    direccion: new Filter(FilterOperation.contains, 'direccion'),
    provincia: new Filter(FilterOperation.any, 'provincia'),
    perito: new Filter(FilterOperation.any, 'perito'),
    tecnico: new Filter(FilterOperation.any, 'tecnico'),
    fechaDesde: new Filter(FilterOperation.greaterOrEqual, 'caseDate'),
    fechaHasta: new Filter(FilterOperation.lessThan, 'caseDate'),
    presupuestoReservaDesde: new Filter(FilterOperation.greaterOrEqual, 'presupuestoReserva'),
    presupuestoReservaHasta: new Filter(FilterOperation.lessOrEqual, 'presupuestoReserva'),
    autorizadoDesde: new Filter(FilterOperation.greaterOrEqual, 'autorizado'),
    autorizadoHasta: new Filter(FilterOperation.lessOrEqual, 'autorizado'),
    costeOperarioDesde: new Filter(FilterOperation.greaterOrEqual, 'costeOperario'),
    costeOperarioHasta: new Filter(FilterOperation.lessOrEqual, 'costeOperario'),
    obraEjecutadaDesde: new Filter(FilterOperation.greaterOrEqual, 'obraEjecutada'),
    obraEjecutadaHasta: new Filter(FilterOperation.lessOrEqual, 'obraEjecutada'),
    obraEjecutadaMesDesde: new Filter(FilterOperation.greaterOrEqual, 'obraEjecutadaMes'),
    obraEjecutadaMesHasta: new Filter(FilterOperation.lessOrEqual, 'obraEjecutadaMes'),
    obraPendienteEjecutarDesde: new Filter(FilterOperation.greaterOrEqual, 'obraPendienteEjecutar'),
    obraPendienteEjecutarHasta: new Filter(FilterOperation.lessOrEqual, 'obraPendienteEjecutar'),
    margenBeneficioOpcion1Desde: new Filter(FilterOperation.greaterOrEqual, 'margenBeneficioOpcion1'),
    margenBeneficioOpcion1Hasta: new Filter(FilterOperation.lessOrEqual, 'margenBeneficioOpcion1'),
    margenBeneficioOpcion2Desde: new Filter(FilterOperation.greaterOrEqual, 'margenBeneficioOpcion2'),
    margenBeneficioOpcion2Hasta: new Filter(FilterOperation.lessOrEqual, 'margenBeneficioOpcion2'),
    duracionObraDesde: new Filter(FilterOperation.greaterOrEqual, 'duracionObra'),
    duracionObraHasta: new Filter(FilterOperation.lessOrEqual, 'duracionObra'),
    fechaAutorizacionDesde: new Filter(FilterOperation.greaterOrEqual, 'fechaAutorizacion'),
    fechaAutorizacionHasta: new Filter(FilterOperation.lessThan, 'fechaAutorizacion'),
    fechaInicioTrabajosDesde: new Filter(FilterOperation.greaterOrEqual, 'fechaInicioTrabajos'),
    fechaInicioTrabajosHasta: new Filter(FilterOperation.lessThan, 'fechaInicioTrabajos'),
    fechaPrevistaFinDeObraDesde: new Filter(FilterOperation.greaterOrEqual, 'fechaPrevistaFinDeObra'),
    fechaPrevistaFinDeObraHasta: new Filter(FilterOperation.lessThan, 'fechaPrevistaFinDeObra'),
    esReapertura: new Filter(FilterOperation.equals, 'esReapertura'),
    fechaReaperturaDesde: new Filter(FilterOperation.greaterOrEqual, 'fechaReapertura'),
    fechaReaperturaHasta: new Filter(FilterOperation.lessThan, 'fechaReapertura')
  };

  public estadoOptions: any[] = [
    { label: 'En curso', value: 'EN CURSO' },
    { label: 'Finalizado', value: 'FINALIZADO' },
    { label: 'Anulado', value: 'ANULADO' }
  ];

  public reaperturaOptions: any[] = [
    { label: 'Sí', value: 'VERDADERO' },
    { label: 'No', value: 'FALSO' }
  ];

  public quickSearchField: Filter = this.filters.id;

  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.provincia, type: 'multiselect', label: 'Provincia', options: this.countriesRegions, base: true },
    { filter: this.filters.compania, type: 'multiselect', label: 'Compañía', options: this.companies, base: true },
    { filter: this.filters.tecnico, type: 'multiselect', label: 'Técnico', options: this.tecnicos, base: true },
    { filter: this.filters.fechaDesde, filterTo: this.filters.fechaHasta, type: 'date', label: 'Fecha', base: true },
    { filter: this.filters.estadoUSG, type: 'select', label: 'Estado', options: this.estadoOptions, base:true },
    { filter: this.filters.direccion, type: 'text', label: 'Dirección', base:true },
    { filter: this.filters.perito, type: 'multiselect', label: 'Perito', options: this.peritos },
    { filter: this.filters.presupuestoReservaDesde, filterTo: this.filters.presupuestoReservaHasta, type: 'number', label: 'Presupuesto', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.autorizadoDesde, filterTo: this.filters.autorizadoHasta, type: 'number', label: 'Autorizado', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.fechaAutorizacionDesde, filterTo: this.filters.fechaAutorizacionHasta, type: 'date', label: 'Fecha autorización' },
    { filter: this.filters.costeOperarioDesde, filterTo: this.filters.costeOperarioHasta, type: 'number', label: 'Coste operario', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.fechaInicioTrabajosDesde, filterTo: this.filters.fechaInicioTrabajosHasta, type: 'date', label: 'Fecha inicio trabajos' },
    { filter: this.filters.fechaPrevistaFinDeObraDesde, filterTo: this.filters.fechaPrevistaFinDeObraHasta, type: 'date', label: 'Fecha prevista fin de obra' },
    { filter: this.filters.duracionObraDesde, filterTo: this.filters.duracionObraHasta, type: 'number', label: 'Duración obra', suffix: ' días' },
    { filter: this.filters.esReapertura, type: 'select', label: 'Reapertura', options: this.reaperturaOptions },
    { filter: this.filters.fechaReaperturaDesde, filterTo: this.filters.fechaReaperturaHasta, type: 'date', label: 'Fecha reapertura' },
    { filter: this.filters.obraEjecutadaDesde, filterTo: this.filters.obraEjecutadaHasta, type: 'number', label: 'Obra ejecutada', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.obraEjecutadaMesDesde, filterTo: this.filters.obraEjecutadaMesHasta, type: 'number', label: 'Obra ejecutada en el mes', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.obraPendienteEjecutarDesde, filterTo: this.filters.obraPendienteEjecutarHasta, type: 'number', label: 'Obra pendiente', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.margenBeneficioOpcion1Desde, filterTo: this.filters.margenBeneficioOpcion1Hasta, type: 'number', label: 'Beneficio %', suffix: ' %', minFractionDigits: 2, maxFractionDigits: 2 },
    { filter: this.filters.margenBeneficioOpcion2Desde, filterTo: this.filters.margenBeneficioOpcion2Hasta, type: 'number', label: 'Beneficio bruto', suffix: ' €', minFractionDigits: 2, maxFractionDigits: 2 }
  ];

  constructor(
    private router: Router,
    private seriousCasesService: SeriousCasesService,
    private regionCountriesService: CountriesRegionsService,
    private companiesService: CompaniesService,
    private expertsService: ExpertsService,
    private topbarService: TopbarService,
    private usersService: UsersService,
    private casesService: CasesService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.topbarService.setTitle("Siniestros Graves");
    this.topbarService.setSubtitle("Expedientes de alto importe o complejidad en seguimiento.");
    
    this.loadCountriesRegions();
    this.loadCompanies();
    this.loadPeritos();
    this.loadTechnicians();
  }

  public async loadData($event: any): Promise<void> {
    this.lastGridEvent = $event;
    this.loading = true;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      sort: this.defaultSort
    };

    if ($event.sortField) {
      params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
    }

    params.filter = FilterBuilder.fromObject(this.filters).build();

    try {
      let response = await firstValueFrom(this.seriousCasesService.all(params));

      this.rows = response.data;
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    } finally {
      this.loading = false;
    }
  }

  /// Clase de color de la etiqueta de estado (ESPEC_TABLA_SINIESTROS_GRAVES §4.2). Un estado sin color propio
  /// se queda con el gris neutro de `.estado`.
  public estadoClass(estado: string): string {
    switch (estado?.trim().toUpperCase()) {
      case 'EN CURSO': return 'estado--en-curso';
      case 'PENDIENTE': return 'estado--pendiente';
      case 'FINALIZADO':
      case 'CERRADO': return 'estado--finalizado';
      case 'ANULADO': return 'estado--anulado';
      default: return '';
    }
  }

  public search(): void {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  /// Abre la ficha del expediente. La vista solo trae la referencia (CaseNumber), así que antes de navegar se busca
  /// el id del expediente por ella. excludeProcessorFilter: este listado no filtra por tramitador, y la ficha tampoco.
  public async openCase(caseNumber: string): Promise<void> {
    let caseNumberFilter = new Filter(FilterOperation.equals, 'caseNumber');
    caseNumberFilter.value = caseNumber;

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject({ caseNumber: caseNumberFilter }).build(),
      fields: { cases: 'id' },
      page: { number: 1, size: 2 },
      custom: { excludeProcessorFilter: true }
    };

    let response = await firstValueFrom(this.casesService.all(params));
    if (response.data.length !== 1) {
      this.messageService.add({ closable: true, severity: 'warn', detail: `No se ha podido abrir el expediente ${caseNumber}` });
      return;
    }

    this.router.navigate(['/cases', response.data[0].id]);
  }

  async loadCountriesRegions() {
    let response = await firstValueFrom(this.regionCountriesService.all());
    this.countriesRegions.length = 0;
    this.countriesRegions.push(...response.data.map(cr => ({ label: cr.name, value: cr.name })));
  }

  async loadCompanies() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let response = await firstValueFrom(this.companiesService.all(params));
    this.companies.push(...response.data.map(c => ({ label: c.name, value: c.name })));
  }

  async loadPeritos() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let response = await firstValueFrom(this.expertsService.all(params));
    this.peritos.push(...response.data.map(e => ({ label: e.name, value: e.name })));
  }

  async loadTechnicians() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let userTypeFilter = new Filter(FilterOperation.contains, 'userType.code');
    userTypeFilter.value = 'technical';
    params.filter = FilterBuilder.fromObject({ userType: userTypeFilter }).build();
    let response = await firstValueFrom(this.usersService.all(params));
    this.tecnicos.push(...response.data.map(u => ({ label: u.name, value: u.name })));
  }

}
